import PropTypes from 'prop-types'
import classNames from 'classnames'

import PictureImgix from '@/components/PictureImgix'

import styles from './Confidence.module.scss'

const ConfidenceItem = ({ title, subtitle, icon }) => (
    <div className={styles.item}>
        <PictureImgix
            folder={`financing/confidence/${icon}`}
            name={`${icon}.png`}
            alt={`Icon ${title}`}
            lazyLoad={false}
            imageClassName={styles.itemImage}
            widths={{
                mobile: 160,
                tablet: 160,
                desktop: 160
            }}
            isUniversal
        />
        <div className={classNames('t-heading3 t-black', styles.itemTitle)}>
            {title}
        </div>
        <div className={classNames('t-heading4 t-black', styles.itemSubtitle)}>
            {subtitle}
        </div>
    </div>
)

ConfidenceItem.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    icon: PropTypes.string
}

const Confidence = () => {
    const items = [
        {
            title: 'Transparent',
            subtitle: 'Affirm tells you up front the total amount you\'ll pay. That number will never go up.',
            icon: 'icon-transparent'
        },
        {
            title: 'Flexible',
            subtitle: 'You choose the payment schedule that works for you.',
            icon: 'icon-flexible'
        },
        {
            title: 'Fair',
            subtitle: 'Affirm won\'t charge you late fees or penalties of any kind, ever.',
            icon: 'icon-fair'
        }
    ]

    return (
        <section className="u-paddingVertical--4xl">
            <div className="container">
                <div className="row row--center-xs">
                    <div className="col col--xs-12 u-flexAlign--center">
                        <h2 className="t-heading2">Buy with confidence</h2>
                        <span className="t-heading3 t-black u-marginBottom--2dot5xl">
                            With Affirm, you always know exactly what you'll owe and when you'll be done paying.
                        </span>
                    </div>
                    <div className={classNames('col col--xs-12', styles.items)}>
                        {items.map((item, index) => {
                            return (
                                <ConfidenceItem
                                    key={`${item.title}-${index}`}
                                    {...item}
                                />
                            )
                        })}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Confidence
